import React from "react";
import "../App.css";
import Fire from "../config/Fire";
import Aux from "../utils/AuxFunctions";
import { withMyDataContext } from "../context/DataProvider";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import SingleMessage from "../utils/Messages/SingleMessage";

const LIMIT = 10;

class ShowData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            messagesData: [],
            lastVisible: null,
            finished: false,
            loading: false,
        }
    }

     componentDidMount() {
        try {
            //this.getAllData(true);
            if(this.props.myDataProvider.newMessage){
                this.props.myDataProvider.setNewMessage(false)
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

     componentDidUpdate(prevProps) {
        if (this.props.myDataProvider.newMessage !== prevProps.myDataProvider.newMessage) {
            this.props.myDataProvider.setNewMessage(false)
        }
    } 

    goBack = () => {
        try{
            this.props.history.goBack()
        }catch(error){
            Aux.handleError(error)
        }
    }

    getAllData = async (isStart) => {
        if (this.state.loading) 
            return;
        let lastVisible = null;
        if (isStart) {
            this.setState({
                requestsData: [],
                finished: false,
                lastVisible: null,
            });
        } else {
            lastVisible = this.state.lastVisible
        }

        try {

            this.setState({ loading: true,})
            await Fire.shared
                .GetMyMessagesData(lastVisible, LIMIT,)
                .then(snapshot => {
                    if (snapshot) {
                        if (snapshot.length < LIMIT || snapshot.empty) {
                            this.setState({ finished: true })
                        }

                        let data = snapshot.docs.map(document => {
                            const doc = document.data();
                            doc.id = document.id;
                            return doc;
                        });
                        this.setState({
                            messagesData: [...this.state.messagesData, ...data],
                            lastVisible: snapshot.docs[snapshot.docs.length - 1],
                            loading: false,
                        });

                    } else {
                        this.setState({ finished: true, loading: false })
                    }
                });
        } catch (error) {
            Aux.handleError(error)
        }
    };


    render() {

        return (
            <div style={{width:"100%"}}>
                <section className="container" >
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                    <div className="reversed-button-hover" style={{display:"flex", alignItems:"center", marginBottom:20}} onClick={this.goBack}>
                        <ChevronLeftIcon style={{marginRight:5}}></ChevronLeftIcon>
                        <h2>Messages</h2>
                    </div>
                </div>
                    {this.props.myDataProvider.messagesData.length <= 0 ? 
                        <div style={{display:"flex", justifyContent:"center"}}>
                            <span style={{marginTop:20}}>You've got no messages yet...</span>
                        </div> :
                  this.props.myDataProvider.messagesData.map((item, index) => (
                        <SingleMessage message={item} key={item.id + index}></SingleMessage>
                    ))}
                </section>
            </div>
        );
    }
}

export default withMyDataContext(ShowData);